@if (!fileError) {
  <div class="crop__cropper">
    <image-cropper
      class="crop__cropper__edit"
      [imageFile]="data.image"
      [maintainAspectRatio]="!!data.cropperOptions?.aspectRatio"
      [aspectRatio]="data.cropperOptions?.aspectRatio"
      [cropperStaticWidth]="data.cropperOptions?.cropperStaticWidth"
      [cropperStaticHeight]="data.cropperOptions?.cropperStaticHeight"
      (imageCropped)="imageCropped($event)"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
      format="jpeg"
      output="base64"
    />
    @if (loading$ | async) {
      <mat-spinner class="crop__spinner" />
    }
  </div>
}

@if (fileError) {
  <span>Erreur lors du chargement de l&apos;image</span>
}

<div class="crop__cta">
  <button class="crop__cta__button" (click)="onClose()" type="button" color="warn" mat-flat-button>Annuler</button>
  <button
    class="crop__cta__button"
    [disabled]="fileError"
    (click)="onSubmit()"
    type="button"
    mat-flat-button
    color="primary"
  >
    Valider
  </button>
</div>
